<ng-container *ngIf="validatorsUpdete$ | async"></ng-container>
<ng-container *ngIf="formChanged$ | async"></ng-container>

<!-- Названия у высоты и ширины поменяны местами намеренно, чтобы высота располагалась по вертикальной оси -->
<form *ngIf="data$ | async" [formGroup]="form" novalidate cslEnterLikeTab class="flex flex-row space-x-2 items-start">
  <mat-form-field appearance="outline" class="dense-input flex-1">
    <mat-label i18n>Высота (мм)</mat-label>
    <input data-testid="facadeHeight" matInput type="number" formControlName="width" />
    <mat-error *ngIf="form.get('width').hasError('required')" i18n>Заполните поле</mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline" class="dense-input flex-1">
    <mat-label i18n>Ширина (мм)</mat-label>
    <input data-testid="facadeWidth" matInput type="number" formControlName="height" />
    <mat-error *ngIf="form.get('height').hasError('required')" i18n>Заполните поле</mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline" class="dense-input basis-1/4">
    <mat-label i18n>Количество</mat-label>
    <input data-testid="facadeCount" matInput type="number" formControlName="count" />
    <mat-error *ngIf="form.get('count').hasError('required')" i18n>Заполните поле</mat-error>
    <mat-error *ngIf="form.get('count').hasError('min')" i18n
      >Мин. значение – {{ form.get('count').getError('min').min }}</mat-error
    >
    <mat-error *ngIf="form.get('count').hasError('max')" i18n
      >Макс. значение – {{ form.get('count').getError('max').max }}</mat-error
    >
  </mat-form-field>
</form>

<div class="mat-caption red-fg mb-4" *ngIf="form.hasError('panelSize') && form.dirty">
  <div i18n
    >Минимальный габаритный размер: {{ form.getError('panelSize').overallSize.height.min }}×{{
      form.getError('panelSize').overallSize.width.min
    }}</div
  >
  <div i18n
    >Максимальный габаритный размер: {{ form.getError('panelSize').overallSize.height.max }}×{{
      form.getError('panelSize').overallSize.width.max
    }}</div
  >
</div>
